// extracted by mini-css-extract-plugin
export default {"container":"ForgotPassword_container__5w9mk","inputContainerfp":"ForgotPassword_inputContainerfp__Lt4vi","submitBTN":"ForgotPassword_submitBTN__Oe+Rb"};